export default {
    width: {
        label: 'Width',
        // defaultUnit: 'px',
        // allowedUnits: ['px'],
        template: 'Range',
    },
    height: {
        label: 'Height',
        // defaultUnit: 'px',
        // allowedUnits: ['px'],
        template: 'Range',
    },
    id: {
        prefix: '#',
        label: 'HTML ID',
        template: 'PrependInput',
    },
    __data: {
        label: 'Data Attributes',
        template: 'DataAttributes',
    },
    src: {
        label: 'URL',
        template: 'Input',
    },
    alt: {
        label: 'Alt Text',
        template: 'Input',
    },
    href: {
        label: 'URL',
        template: 'Input',
    },
    poster: {
        label: 'Poster',
        accept: 'image/*',
        template: 'ImagePreview',
    },
    controls: {
        onValue: true,
        onLabel: 'ON',
        offValue: false,
        offLabel: 'OFF',
        template: 'Switch',
        defaultValue: true,
        label: 'Video Controls',
    },
    loop: {
        onValue: true,
        onLabel: 'ON',
        offValue: false,
        offLabel: 'OFF',
        template: 'Switch',
        defaultValue: false,
        label: 'Loop',
    },
    muted: {
        onValue: true,
        onLabel: 'ON',
        offValue: false,
        offLabel: 'OFF',
        template: 'Switch',
        defaultValue: false,
        label: 'Mute',
    },
    autoplay: {
        onValue: true,
        onLabel: 'ON',
        offValue: false,
        offLabel: 'OFF',
        template: 'Switch',
        defaultValue: false,
        label: 'Autoplay',
    },
    fullscreen: {
        onValue: true,
        onLabel: 'ON',
        offValue: false,
        offLabel: 'OFF',
        template: 'Switch',
        defaultValue: true,
        label: 'Allow Fullscreen',
    },
    target: {
        template: 'Tab',
        defaultValue: '',
        inputType: 'boxed',
        label: 'Open Link In',
        options: [
            { label: 'Same Tab', value: '' },
            { label: 'New Tab', value: '_blank' },
            { label: 'New Window', value: '_new' },
        ],
    },
    __class__overlayType: {
        template: 'Tab',
        defaultValue: '',
        inputType: 'boxed',
        label: 'Overlay Style',
        options: [
            { value: '', label: 'None' },
            { value: 'color-overlay', label: 'Color Overlay' },
            { value: 'gradient-overlay', label: 'Gradient Overlay' },
        ],
    },
};
